export default "__VITE_ASSET__652a66a0__"